import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import BasicText from './basicText'

import '../debtPayment.scss'

const EmailNotification = (props) => {

    return (
      <Container className='debtpayment-notification-container'>
        <Row className=''>
            <Col md='auto'>
              <Row>
                <Col>
                  <BasicText text='אישור התשלום נשלח למייל' />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BasicText text={props.email} />
                </Col>
              </Row>
            </Col>
        </Row>
      </Container>
    );
}

export default EmailNotification